var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modul"},[_c('div',{staticClass:"modul-top"},[_c('div',{staticClass:"caidan-img"},[_c('img',{attrs:{"src":require("../../../assets/image/caidan.png"),"alt":"菜单"}})]),_c('div',{staticClass:"caidan-title"},[_vm._v("\n      检测报告\n    ")])])])
}]

export { render, staticRenderFns }